<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:90px !important;">
    </div>

    <div class="tile is-parent" v-show="!saveSuccess">
      <article class="tile is-child notification is-danger">
        <p class="title" style="font-size:1.5rem;padding-bottom:5px;">กรุณาให้คะแนนความพึงพอใจ</p>
        <div class="content">
            <p v-if="errors.length" class="has-text-danger">
                กรุณาให้คะแนนให้ครบทุกข้อ
            </p>
            <!-- <div class="field">
                <label class="label is-size-6" style="color:#333333;">ระบบแจ้งความคืบหน้าการซ่อม<br>ผ่านแอปพิเคชั่น V Group Linked</label>
                <div class="control">
                    <star-rating :show-rating="false" v-model="application_rating" active-color="#ff0000"></star-rating>
                </div>
            </div>
            <div class="field">
                <label class="label is-size-6" style="color:#333333;">การให้บริการโดยภาพรวมของศูนย์บริการนี้</label>
                <div class="control">
                    <star-rating :show-rating="false" v-model="overall_rating" active-color="#ff0000"></star-rating>
                </div>
            </div> -->
            <div class="field">
                <label class="label is-size-6" :style="'color:' + (starCheck1 ? '#333333' : 'red')">1. ความพึงพอใจโดยรวมเรื่องการนัดหมายล่วงหน้าก่อนเข้ารับบริการ</label>
                <div class="control">
                  <!-- <table>
                    <tr>
                      <td v-for="(val, index) in starPoints " v-bind:key="index">
                        <figure :class="'image is-32x32 no-margin'" @click="starCheck1=true; starSelect1 = index">
                          <img :class="'is-rounded ' + (parseInt(starSelect1) == parseInt(index) ? 'active' : 'no-active')" :src="val">
                        </figure>
                      </td>
                    </tr>
                  </table> -->
                  <star-rating :max-rating=5 :show-rating="true" v-model="booking_rating" active-color="#ff0000"></star-rating>
                </div>
            </div>
            <div class="field">
                <label class="label is-size-6" :style="'color:' + (starCheck2 ? '#333333' : 'red')">2. ความพึงพอใจโดยรวมในขั้นตอนการรับรถของที่ปรึกษางานบริการ</label>
                <div class="control">
                  <!-- <table>
                    <tr>
                      <td v-for="(val, index) in starPoints " v-bind:key="index">
                        <figure :class="'image is-32x32 no-margin'" @click="starCheck2=true; starSelect2 = index">
                          <img :class="'is-rounded ' + (parseInt(starSelect2) == parseInt(index) ? 'active' : 'no-active')" :src="val">
                        </figure>
                      </td>
                    </tr>
                  </table> -->
                  <star-rating :max-rating=5 :show-rating="true" v-model="receive_rating" active-color="#ff0000"></star-rating>
                </div>
            </div>
            <div class="field">
                <label class="label is-size-6" :style="'color:' + (starCheck3 ? '#333333' : 'red')">3. ความพึงพอใจโดยรวมในขั้นตอนการส่งมอบรถ</label>
                <div class="control">
                  <!-- <table>
                    <tr>
                      <td v-for="(val, index) in starPoints " v-bind:key="index">
                        <figure :class="'image is-32x32 no-margin'" @click="starCheck3=true; starSelect3 = index">
                          <img :class="'is-rounded ' + (parseInt(starSelect3) == parseInt(index) ? 'active' : 'no-active')" :src="val">
                        </figure>
                      </td>
                    </tr>
                  </table> -->
                  <star-rating :max-rating=5 :show-rating="true" v-model="advisor_rating" active-color="#ff0000"></star-rating>
                </div>
            </div>
            <div class="field">
                <label class="label is-size-6" :style="'color:' + (starCheck4 ? '#333333' : 'red')">4. ความพึงพอใจโดยรวมต่อคุณภาพงานซ่อม</label>
                <div class="control">
                  <!-- <table>
                    <tr>
                      <td v-for="(val, index) in starPoints " v-bind:key="index">
                        <figure :class="'image is-32x32 no-margin'" @click="starCheck4=true; starSelect4 = index">
                          <img :class="'is-rounded ' + (parseInt(starSelect4) == parseInt(index) ? 'active' : 'no-active')" :src="val">
                        </figure>
                      </td>
                    </tr>
                  </table> -->
                  <star-rating :max-rating=5 :show-rating="true" v-model="quality_rating" active-color="#ff0000"></star-rating>
                </div>
            </div>
            <div class="field">
                <label class="label is-size-6" :style="'color:' + (starCheck5 ? '#333333' : 'red')">5. ความพึงพอใจโดยรวมต่อสถานที่และสิ่งอำนวยความสะดวก</label>
                <div class="control">
                  <!-- <table>
                    <tr>
                      <td v-for="(val, index) in starPoints " v-bind:key="index">
                        <figure :class="'image is-32x32 no-margin'" @click="starCheck5=true; starSelect5 = index">
                          <img :class="'is-rounded ' + (parseInt(starSelect5) == parseInt(index) ? 'active' : 'no-active')" :src="val">
                        </figure>
                      </td>
                    </tr>
                  </table> -->
                  <star-rating :max-rating=5 :show-rating="true" v-model="deliver_rating" active-color="#ff0000"></star-rating>
                </div>
            </div><br>
            <div class="field">
                <label class="label is-size-6" :style="'color:' + (starCheck5 ? '#333333' : 'red')">ท่านจะแนะนำศูนย์บริการแห่งนี้ให้กับญาติพี่น้อง หรือเพื่อนของท่านหรือไม่</label>
                <div class="control">
                  <input type="radio" name="recommend" v-model="recommend" value="Y"> แนะนำ &nbsp;&nbsp;&nbsp;&nbsp;
                  <input type="radio" name="recommend" v-model="recommend" value="N"> ไม่แนะนำ
                </div>
            </div><br>
            <div class="field">
                <label class="label is-size-6" style="color:#333333;">ข้อแนะนำเพื่อการปรับปรุงศูนย์บริการ</label>
                <div class="control">
                    <textarea class="textarea" v-model="comment" placeholder="" style="min-height: 65px;"></textarea>
                </div>
            </div>
        </div>
      </article><br>
      <button class="button is-danger is-fullwidth" v-on:click="submitRating" v-show="!saving">{{ btn_action }}</button>
      <span v-show="saving">กรุณารอสักครู่ กำลังส่งคะแนนค่ะ...</span>
    </div>

    <article class="message is-success" v-show="saveSuccess">
      <div class="message-header">
        <p>ส่งคะแนนเรียบร้อยแล้ว</p>
        <button class="delete" aria-label="delete"></button>
      </div>
      <div class="message-body">
        ขอบคุณที่ไว้วางใจ วี กรุ๊ป ตลอด 20 ปี <br><br>
        <button class="button is-info" v-on:click="closeWindow">ปิดหน้าต่างนี้</button>
      </div>
    </article>
    <br><br>
  </div>
</template>
<style scoped>
.field,
.control {
  text-align: left;
}
.banner {
  background-color: #000;
}
.notification.is-danger {
  color: #333;
  background-color: #eee;
}
.notification {
  padding: 1.25rem .5rem 1.25rem .5rem;
}
.vue-star-rating {
  padding-left: 20px;
}
.no-margin {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.no-active {
  opacity: .4;
}
.active {
  opacity: 1;
}
</style>
<script>
import StarRating from 'vue-star-rating'

export default {
  name: 'Home',
  beforeCreate () {
  },
  components: {
    StarRating
  },
  data: () => ({
    size: 200,
    jobId: '',
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    starPoints: [
      'https://foxfox-honda.web.app/static/img/rating/point_10.png',
      'https://foxfox-honda.web.app/static/img/rating/point_8.png',
      'https://foxfox-honda.web.app/static/img/rating/point_6.png',
      'https://foxfox-honda.web.app/static/img/rating/point_4.png',
      'https://foxfox-honda.web.app/static/img/rating/point_2.png',
      'https://foxfox-honda.web.app/static/img/rating/point_0.png'
    ],
    starSelect1: null,
    starSelect2: null,
    starSelect3: null,
    starSelect4: null,
    starSelect5: null,
    starCheck1: true,
    starCheck2: true,
    starCheck3: true,
    starCheck4: true,
    starCheck5: true,
    // overall_rating: 0,
    // application_rating: 0,
    booking_rating: 0,
    receive_rating: 0,
    advisor_rating: 0,
    quality_rating: 0,
    deliver_rating: 0,
    comment: '',
    saveSuccess: false,
    btn_action: 'ส่งคะแนน',
    errors: [],
    saving: false,
    recommend: null
  }),
  async mounted () {
    this.$liff.init({ liffId: this.$liffId_Rating }, function (data) {})
    let _this = this
    _this.branch = this.$branchList
    await this.checkLiffLogin()
    const queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    const params = new URLSearchParams(queryString)
    _this.jobId = params.get('jobId')
  },
  methods: {
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({redirectUri: window.location})
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async submitRating (e) {
      if (!this.checkForm2(e)) {
        return false
      }
      var _this = this
      _this.saving = true
      let params = {
        jobId: _this.jobId,
        userId: _this.profile.userId,
        // overall_rating: _this.overall_rating,
        // application_rating: _this.application_rating,
        booking_rating: _this.booking_rating,
        receive_rating: _this.receive_rating,
        advisor_rating: _this.advisor_rating,
        quality_rating: _this.quality_rating,
        deliver_rating: _this.deliver_rating,
        recommend: _this.recommend,
        comment: _this.comment
      }
      // let params = {
      //   jobId: _this.jobId,
      //   userId: _this.profile.userId,
      //   // overall_rating: _this.overall_rating,
      //   // application_rating: _this.application_rating,
      //   rating1: _this.starSelect1,
      //   rating2: _this.starSelect2,
      //   rating3: _this.starSelect3,
      //   rating4: _this.starSelect4,
      //   rating5: _this.starSelect5,
      //   comment: _this.comment
      // }
      await this.$axios
        .post(`${this.$apiUrl}saveRatingNew`, params)
        .then(response => {
          _this.saveSuccess = true
        })
      await this.$axios
        .get(`${this.$apiUrl}getCarInfo?carId=${this.jobId}`)
        .then(async (response) => {
          let paramsVgroup = {
            'timestamp': this.formatDate(new Date()),
            'rating1': _this.booking_rating,
            'rating2': _this.receive_rating,
            'rating3': _this.advisor_rating,
            'rating4': _this.quality_rating,
            'rating5': _this.deliver_rating,
            'comment': _this.comment,
            'runNo': response.data.runNo,
            'frameNo': response.data.frameNo,
            'licenseNo': response.data.licenseNo,
            'branchId': response.data.branchId,
            'customerName': response.data.customerName,
            'updatedBy': _this.profile.userId
          }
          let headers = {
            'Application-Key': 'YWRiNjBhZTY4NDY4YjYyY2ZhZGU3N2NkMTkxOTMwYTg1YmQ5NDhhOGQ4NDE0N2ZiYzZhNTNkZmIzMzUzZTc4Yw'
          }
          await this.$axios
            .post(`https://api.betaskthai.com/vgroup_api/v1/Vsales/sysUser/addRatingVlink`, paramsVgroup, {
              headers: headers
            })
        })
    },
    checkForm2 (e) {
      var _this = this
      _this.errors = []
      if (_this.booking_rating !== null && _this.receive_rating !== null && _this.advisor_rating !== null &&
          _this.quality_rating !== null && _this.deliver_rating !== null && _this.booking_rating !== 0 &&
          _this.receive_rating !== 0 && _this.advisor_rating !== 0 && _this.quality_rating !== 0 &&
          _this.deliver_rating !== 0 && _this.recommend !== null) {
        return true
      }

      if (_this.booking_rating === null || _this.booking_rating === 0) {
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจโดยรวมเรื่องการนัดหมายล่วงหน้าก่อนเข้ารับบริการ')
      }
      if (_this.receive_rating === null || _this.receive_rating === 0) {
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจโดยรวมในขั้นตอนการส่งมอบรถ')
      }
      if (_this.advisor_rating === null || _this.advisor_rating === 0) {
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจโดยรวมในขั้นตอนการส่งมอบรถ')
      }
      if (_this.quality_rating === null || _this.quality_rating === 0) {
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจโดยรวมต่อคุณภาพงานซ่อม')
      }
      if (_this.deliver_rating === null || _this.deliver_rating === 0) {
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจโดยรวมต่อสถานที่และสิ่งอำนวยความสะดวก')
      }
      if (_this.recommend === null) {
        _this.errors.push('กรุณาเลือก ท่านจะแนะนำศูนย์บริการแห่งนี้ให้กับญาติพี่น้อง หรือเพื่อนของท่านหรือไม่')
      }
      return false
    },
    checkForm (e) {
      var _this = this
      _this.errors = []
      if (_this.starSelect1 !== null && _this.starSelect2 !== null && _this.starSelect3 !== null && _this.starSelect4 !== null && _this.starSelect5 !== null) {
        return true
      }

      if (_this.starSelect1 === null) {
        _this.starCheck1 = false
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจการให้บริการโดยภาพรวมของศูนย์บริการนี้')
      }
      if (_this.starSelect2 === null) {
        _this.starCheck2 = false
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจต่อระบบการแจ้งความคืบหน้าการซ่อมผ่านแอปพิเคชั่น')
      }
      if (_this.starSelect3 === null) {
        _this.starCheck3 = false
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจต่อระบบการแจ้งความคืบหน้าการซ่อมผ่านแอปพิเคชั่น')
      }
      if (_this.starSelect4 === null) {
        _this.starCheck4 = false
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจต่อระบบการแจ้งความคืบหน้าการซ่อมผ่านแอปพิเคชั่น')
      }
      if (_this.starSelect5 === null) {
        _this.starCheck5 = false
        _this.errors.push('กรุณาให้คะแนน ความพึงพอใจต่อระบบการแจ้งความคืบหน้าการซ่อมผ่านแอปพิเคชั่น')
      }
    },
    padTo2Digits (num) {
      return num.toString().padStart(2, '0')
    },
    formatDate (date) {
      return (
        [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate())
        ].join('-') +
        ' ' +
        [
          this.padTo2Digits(date.getHours()),
          this.padTo2Digits(date.getMinutes()),
          this.padTo2Digits(date.getSeconds())
        ].join(':')
      )
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    getProfile_dev () {
      this.profile = {
        'displayName': 'Pamorn Trivorrarat',
        'pictureUrl': 'https://profile.line-scdn.net/0hehdTWCiWOkdZLRKhl6VFEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
        'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
        'userId': 'U691b2080970333bbeb4930dadc6618b6'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Rating.vue